<template>
    <span class="reo-tip-dialog" :style="{'--icon-width': (iconWidth ?? 14) + 'px'}">
        <reo-dialog
            v-if="show"
            :class="dialogClass"
            :isHorizontally="true"
            :show-button="false"
            :isBottomWhenMobile="isBottomWhenMobile"
            @cancel="close"
        >
            <slot></slot>
        </reo-dialog>
        <i class="tip-icon icon-co_tips_line" @click="show=true"/>
    </span>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';

export default Vue.extend({
    components: {
        ReoDialog
    },
    props:{
        iconWidth: Number,
        dialogClass: String,
        isBottomWhenMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {

        return {
            show: false
        };

    },
    methods: {
        close() {

            this.show = false;

        }
    },
});
</script>

<style lang="less" scoped>
.reo-tip-dialog {
    position: relative;
    display: inline-flex;
    align-items: end;
    vertical-align: baseline;
    .tip-icon{
        cursor: pointer;
        font-size: var(--icon-width);
    }
}
</style>
